import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Row, Modal, Button } from "react-bootstrap";
import { InputBoxComponent } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { TextField } from "@material-ui/core";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../../../../function/InputNumberFunc";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import MultipleImageUploadComponent from "../../../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import { InputAdornment, InputBase } from '@material-ui/core';
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import countryJson from "../../../../../../localization/country.json";
import LeftSideNavigation from "../../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../../navigationSection/BottomNavigationMobile";
import {
  DistanceData,
  OrderTimeSlots,
  MinimumLeadTime,
  CutOffTimeData,
  delivery_options,

} from "../../../../../../../enums/DropDownDataTable";
import isEmpty from "../../../../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_new_subscription_for_vendor,
  maintain_delivery_people_data
} from "../../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import Media from "react-media";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { errorAlert } from "../../../../../../../function/alert";
import DeliveryPersonInfoReuse from "../../../../../../reusableComponents/DeliveryPersonReuseComponent/DeliveryPersonInfoReuse";
import { ButtonReusableComponent, IconButtonReusableComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import AddOrEditDeliveryPersonModal from "../../../../../../reusableComponents/DeliveryPersonReuseComponent/AddOrEditDeliveryPersonModal";
import { add_delivery_person, delete_delivery_person, edit_delivery_person, get_delivery_person } from "../../../../../../../store/actions/DeliveryPersonActions/DeliveryPersonActions";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { Image } from "react-bootstrap";

const validationSchema = yup.object({
  distance: yup.string().required("distance is required"),
  minimum_order_value: yup.string().required("minimum order value is required"),
  // max_date: yup
  //   .string()
  //   .required("placement is required")
  //   .min(1, "minimum 1 digit"),
  cut_off_time: yup.string().required("cut off time is required"),
  order_time_slot: yup.number().required("order time slot is required"),
  minimum_lead: yup.number().required("minimum lead time is required")
});

export const EditCasualHomeDelivery = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [showAdd, setShowAdd] = useState(false);
  const handleShowAdd = () => setShowAdd(true);
  const handleCloseAdd = () => {
    setShowAdd(false);
    setEditDeliveryPerson(null);
  }
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false)

  const [deliveryPersonArr, setDeliveryPersonArr] = useState([]);
  const [state, setState] = useState({
    auto_accept: false,
    order_for_future: false,
    order_status_item_level: false,
    on_click_Open_model: false,
  });

  const localizationText = useSelector((state) => {
    return !isEmpty(
      state?.auth?.user?.VendorUser?.country_code &&
      state?.auth?.user?.VendorUser?.country
    )
      ? state?.auth?.user?.VendorUser?.country_code +
      state?.auth?.user?.VendorUser?.country
      : "+91IN";
  });

  const role = useSelector((state) => {
    return state?.auth?.user?.VendorUser?.role;
  });

  const onClickhomeDeliveryService = (type) => (e) => {
    if (type === "accept") {
      setState({
        ...state,
        auto_accept: !state.auto_accept,
      });
    } else if (type === "MaintainOrderStatus") {
      setState({
        ...state,
        order_status_item_level: !state.order_status_item_level,
      });
    } else {
      setState({
        ...state,
        order_for_future: !state.order_for_future,
      });
    }
  };

  useEffect(() => {
    let token = props?.auth?.user?.accessToken;
    dispatch(get_delivery_person(token))
    setState({
      auto_accept:
        props.subscriptionData &&
          props.subscriptionData.auto_accept === undefined
          ? false
          : props.subscriptionData && props.subscriptionData.auto_accept,
      order_for_future:
        props.subscriptionData &&
          props.subscriptionData.order_for_future === undefined
          ? false
          : props.subscriptionData && props.subscriptionData.order_for_future,
      order_status_item_level:
        props.subscriptionData?.order_status_item_level === undefined
          ? false
          : props.subscriptionData?.order_status_item_level,
    });
    if (
      props.subscriptionData &&
      props.subscriptionData.distance !== undefined &&
      props.subscriptionData.distance !== null
    ) {
      formik.setFieldValue("distance", props.subscriptionData.distance);
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.minimum_order_value !== undefined &&
      props?.subscriptionData?.minimum_order_value !== null
    ) {
      formik.setFieldValue(
        "minimum_order_value",
        props?.subscriptionData?.minimum_order_value
      );
    }
    if (
      props.subscriptionData &&
      props.subscriptionData.max_date !== undefined &&
      props.subscriptionData.max_date !== null
    ) {
      formik.setFieldValue(
        "max_date",
        props.subscriptionData && props.subscriptionData.max_date
      );
    }
    if (
      props.subscriptionData &&
      props.subscriptionData.cut_off_time !== undefined &&
      props.subscriptionData.cut_off_time !== null
    ) {
      formik.setFieldValue("cut_off_time", props.subscriptionData.cut_off_time);
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.order_time_slot !== undefined &&
      props?.subscriptionData?.order_time_slot !== null
    ) {
      formik.setFieldValue(
        "order_time_slot",
        props?.subscriptionData?.order_time_slot
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.minimum_lead !== undefined &&
      props?.subscriptionData?.minimum_lead !== null
    ) {
      formik.setFieldValue(
        "minimum_lead",
        props?.subscriptionData?.minimum_lead
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.auto_cancel_open_restaurant !== undefined &&
      props?.subscriptionData?.auto_cancel_open_restaurant !== null
    ) {
      formik.setFieldValue(
        "auto_cancel_open_restaurant",
        props?.subscriptionData &&
        props?.subscriptionData?.auto_cancel_open_restaurant
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.auto_cancel_close_restaurant !== undefined &&
      props?.subscriptionData?.auto_cancel_close_restaurant !== null
    ) {
      formik.setFieldValue(
        "auto_cancel_close_restaurant",
        props?.subscriptionData &&
        props?.subscriptionData?.auto_cancel_close_restaurant
      );
    }
    if (
      props?.subscriptionData &&
      props?.subscriptionData?.delivery_charges !== undefined &&
      props?.subscriptionData?.delivery_charges !== null
    ) {
      formik.setFieldValue(
        "delivery_charges",
        props?.subscriptionData &&
        props?.subscriptionData?.delivery_charges
      );
    }
  }, [props.subscriptionData]);

  useEffect(() => {
    if (props?.subscription) {
      formik.setFieldValue(
        "delivery_partner",
        props?.subscription &&
        props?.subscription?.delivery_partner
      );
      formik.setFieldValue('deliveryConfig', props?.subscription?.deliveryConfig);
    }
  }, [props?.subscription]);

  useEffect(() => {
    if (props?.deliveryInfo) {
      setDeliveryPersonArr(props?.deliveryInfo)
    }
  }, [props?.deliveryInfo])


  const formik = useFormik({
    initialValues: {
      distance: "",
      minimum_order_value: "",
      max_date: "",
      cut_off_time: "",
      order_time_slot: 15,
      minimum_lead: 15,
      auto_cancel_open_restaurant: 1,
      auto_cancel_close_restaurant: 5,
      delivery_partner: 1,
      deliveryConfig: {
        userCharge: "",
        merchantCharge: "",
        amealioCharge: "",
        cancelRefund: "",
        isFixed: false,
        isPercentage: false,
        borneByMerchant: false,
        fixedCharges: {
          below3: {
            merchant: '',
            user: '',
            amealio: '',
            borneByMerchant: false
          },
          above3: {
            merchant: '',
            user: '',
            amealio: '',
            borneByMerchant: false
          }
        }
      },
    },
    validationSchema,

    onSubmit: (values) => {
      var valueData = {
        value:
          state.auto_accept === false &&
            state.order_for_future === false &&
            state.order_status_item_level === false &&
            values.distance === "" &&
            values.minimum_order_value === "" &&
            values.max_date === "" &&
            values.cut_off_time === ""
            ? false
            : true,
        auto_accept: state.auto_accept,
        order_for_future: state.order_for_future,
        order_status_item_level: state.order_status_item_level,
        distance: values.distance,
        minimum_order_value: values.minimum_order_value,
        max_date: values.max_date,
        cut_off_time: values.cut_off_time,
        order_time_slot: values.order_time_slot,
        minimum_lead: values.minimum_lead,
        delivery_charges: values.delivery_charges,
        delivery_partner: values.delivery_partner,
        deliveryConfig: values.deliveryConfig,
        auto_cancel_open_restaurant: values.auto_cancel_open_restaurant,
        auto_cancel_close_restaurant: values.auto_cancel_close_restaurant,
      };

      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;
      let formData = props.allSubscriptionsData;
      if (props?.casualDiningService) {
        formData.casual_dining_status.ordering.home_delivery = valueData;
      } else if (props?.fastFoodDiningService) {
        formData.fast_food_dining_status.ordering.home_delivery = valueData;
      } else if (props?.multiDiningService) {
        formData.multi_service_business_status.ordering.home_delivery =
          valueData;
      }
      formData.delivery_partner = values?.delivery_partner;
      formData.deliveryConfig = values?.deliveryConfig;
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Home delivery changes added successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-ordering-subscription");
  };

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    if (formik.values.delivery_partner === 2 && !formik.values.deliveryConfig.isFixed && !formik.values.deliveryConfig.isPercentage) {
      errorAlert('Fixed or Percentage Distribution is Must');
      return
    }
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.distance) {
      let distanceElement = document.getElementById("distance");
      distanceElement.focus();
    } else if (formik.errors && formik.errors.minimum_order_value) {
      let minimum_order_valueElement = document.getElementById(
        "minimum_order_value"
      );
      minimum_order_valueElement.focus();
    }
    // else if (formik.errors && formik.errors.max_date) {
    //   let max_dateElement = document.getElementById("max_date");
    //   max_dateElement.focus();
    // }
    else if (formik.errors && formik.errors.cut_off_time) {
      let cut_off_timeElement = document.getElementById("cut_off_time");
      cut_off_timeElement.focus();
    } else if (formik.errors && formik.errors.order_time_slot) {
      let order_time_slotElement = document.getElementById("order_time_slot");
      order_time_slotElement.focus();
    } else if (formik.errors && formik.errors.minimum_lead) {
      let minimum_leadElement = document.getElementById("minimum_lead");
      minimum_leadElement.focus();
    }
    // else if (formik.errors && formik.errors.auto_cancel) {
    //   let auto_cancelElement = document.getElementById("auto_cancel");
    //   auto_cancelElement.focus();
    // }
  }, [count]);

  useEffect(() => {
    if (formik.values.delivery_partner === 2 && !formik.values.deliveryConfig.isFixed && !formik.values.deliveryConfig.isPercentage) {
      formik.setFieldValue("deliveryConfig.isPercentage", true);
      formik.setFieldValue("deliveryConfig.userCharge", 50);
      formik.setFieldValue("deliveryConfig.merchantCharge", 50);
      formik.setFieldValue("deliveryConfig.amealioCharge", 0);
    }
  }, [formik?.values.delivery_partner])

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );

  const [removePerson, setRemovePerson] = useState(false);
  const [deleteData, setDeleteData] = useState({
    deleteInfo: "",
    index: null
  })
  const [indexOfPersonToRemove, setIndexOfPersonToRemove] = useState(undefined)

  const handleShowDel = (data, index) => {
    let token = props.auth?.user?.accessToken;
    dispatch(delete_delivery_person(token, data?._id, onSuccessDelete))
  }
  const onSuccessDelete = () => {
    setRemovePerson(false);
    setDeleteData({
      ...deleteData,
      deleteInfo: "",
      index: null
    })
  }
  const handleCloseDel = () => {
    setRemovePerson(false);
    setDeleteData({
      ...deleteData,
      deleteInfo: "",
      index: null
    })
    setIndexOfPersonToRemove(undefined)
  }
  const [editDeliveryPerson, setEditDeliveryPerson] = useState(null);
  const [editDeliveryPersonIndex, setEditDeliveryPersonIndex] = useState(null);
  /**
   * @DESC Add Delivery Person
   */
  const onClickAddEditDeliveryPerson = (data) => {

    const token = props.auth.user.accessToken
    if (editDeliveryPerson !== null) {
      dispatch(edit_delivery_person(token, data, editDeliveryPersonIndex))
    } else {
      dispatch(add_delivery_person(token, data, editDeliveryPersonIndex))
    }
    setShowAdd(false);
    setEditDeliveryPerson(null);
  }


  /**
   * @DESC Edit Delivery Person
   */
  const onClickEditDeliveryPerson = (data, index) => () => {
    setEditDeliveryPerson(data)
    setEditDeliveryPersonIndex(data?._id)
    setShowAdd(true)
  }

  /**
   * @DESC Remove Delivery Person
   */
  const handleRemovePerson = () => {
    if (indexOfPersonToRemove !== undefined) {
      const updatedDeliveryPersonInfo = [...formik.values.delivery_Person_Info];
      updatedDeliveryPersonInfo.splice(indexOfPersonToRemove, 1);

      formik.setValues({
        ...formik.values,
        delivery_Person_Info: updatedDeliveryPersonInfo,
      });

      handleCloseDel();
    }
  };

  const [formData, setFormData] = useState(null);

  const onValueRedirect = (data) => {
    setFormData([...formData, data]);
    handleCloseAdd();
  };

  const confirmDeleteModal = (data, index) => {
    setDeleteData({
      ...deleteData,
      deleteInfo: data,
      index: index
    })
    setRemovePerson(true);
  }

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/edit-ordering-subscription"
                displayText="Back"
              />
              <br />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="Food Delivery Settings"
                  // displayEdit={state.editButton}
                  // onClickEdit={editClick}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Auto - Accept
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.auto_accept ? false : true}
                      checkedBox={state.auto_accept ? false : true}
                      onChange={onClickhomeDeliveryService("accept")}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={role === 'superadmin' ? false : true}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Distance
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                name="distance"
                                id="distance"
                                className={`w-100 ${formik.errors.distance &&
                                  formik.touched.distance
                                  ? "enError outlined-KilometersAway"
                                  : "outlined-KilometersAway"
                                  }`}
                                onChange={formik.handleChange}
                                value={formik.values.distance}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.distance &&
                                  formik.touched.distance
                                }
                                IconComponent={KeyboardArrowDownIcon}
                                disabled={disabled}
                              >
                                {DistanceData &&
                                  DistanceData.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <Media query="(min-width: 992px)">
                              <p className="f12-500">
                                {countryJson[localizationText] &&
                                  countryJson[localizationText].distance}
                              </p>
                            </Media>
                            <Media query="(max-width: 992px)">
                              <p className="f12-500">
                                KM
                                <br />
                                away
                              </p>
                            </Media>
                          </div>
                          <div className="col-6">
                            {formik.errors.distance &&
                              formik.touched.distance ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.distance}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    *Minimum Order Value
                    <div className="f11-400 opacity5">
                      (Minimum order value above which orders can be placed)
                    </div>
                  </div>
                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <NewInputText
                                controlClass={"minimum_order_value"}
                                extraClass={`mb-0 ${formik.errors.minimum_order_value &&
                                  formik.touched.minimum_order_value
                                  ? "enError"
                                  : ""
                                  }`}
                                inputType="number"
                                onInput={maxLengthCheck}
                                maxLength={5}
                                onKeyDown={InputNumberFunc}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                // labelText="Rupees"
                                name="minimum_order_value"
                                onChange={formik.handleChange}
                                value={formik.values.minimum_order_value}
                                onFocusOut={formik.handleBlur}
                                disabled={disabled}
                              />
                            </FormControl>
                          </div>
                          <div className="col-6">
                            <p className="f12-500">Rupees</p>
                          </div>
                          <div className="col-6">
                            {formik.errors.minimum_order_value &&
                              formik.touched.minimum_order_value ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.minimum_order_value}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Orders Enabled for Future Date and Time
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.order_for_future ? false : true}
                      checkedBox={state.order_for_future ? false : true}
                      onChange={onClickhomeDeliveryService("FutureOrder")}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={role === 'superadmin' ? false : true}
                    />
                  </div>
                </div>
                {state.order_for_future ? (
                  <div className="d-flex align-items-center justify-content-between py-3">
                    <div className=" col-6 col-md-8 col-lg-6 p-0">
                      <div className="f12-500">
                        Placement cannot come more than
                      </div>
                    </div>
                    <div className="col-6 col-md-4 col-lg-6">
                      <Row>
                        <Col md={12}>
                          <div className="row align-items-center">
                            <div className="col-9 col-md-6">
                              <FormControl
                                variant="outlined"
                                className={"w-100"}
                              >
                                <NewInputText
                                  controlClass={"max_date"}
                                  extraClass={`mb-1 mt-4 ${formik.errors.max_date &&
                                    formik.touched.max_date
                                    ? "enError"
                                    : ""
                                    }`}
                                  inputType="number"
                                  onInput={maxLengthCheck}
                                  maxLength={2}
                                  onKeyDown={InputNumberFunc}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  // labelText="Days"
                                  name="max_date"
                                  onChange={formik.handleChange}
                                  value={formik.values.max_date}
                                  onFocusOut={formik.handleBlur}
                                  disabled={disabled}
                                />
                              </FormControl>
                            </div>
                            <div className="col-md-6 col-3">
                              <p className="f12-500">Days</p>
                            </div>
                            <div className="col-6">
                              {/* {formik.errors.max_date && formik.touched.max_date ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.max_date}
                            </div>
                          ) : null} */}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ) : null}

                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    *Food Delivery Time Slot
                    <div className="f11-400 opacity5">
                      (Users will be given slots in these intervals to make Food
                      Delivery request during next business hours)
                    </div>
                  </div>

                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                name="order_time_slot"
                                id="order_time_slot"
                                disabled={disabled}
                                className={`w-100 ${formik.errors.order_time_slot &&
                                  formik.touched.order_time_slot
                                  ? "enError outlined-KilometersAway"
                                  : "outlined-KilometersAway"
                                  }`}
                                onChange={formik.handleChange}
                                value={formik.values.order_time_slot}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.order_time_slot &&
                                  formik.touched.order_time_slot
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {OrderTimeSlots &&
                                  OrderTimeSlots.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <p className="f12-500">Minutes</p>
                          </div>
                          <div className="col-6">
                            {formik.errors.order_time_slot &&
                              formik.touched.order_time_slot ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.order_time_slot}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-7 col-lg-6 p-0">
                    *Minimum Lead Time
                    <div className="f11-400 opacity5">
                      (Amount of time from opening of the restaurant to deliver
                      first order)
                    </div>
                  </div>
                  <div className="col-6 col-md-5 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl
                              variant="outlined"
                              className={"w-100"}
                              disabled={disabled}
                            >
                              <Select
                                name="minimum_lead"
                                id="minimum_lead"
                                disabled={disabled}
                                className={`w-100 ${formik.errors.minimum_lead &&
                                  formik.touched.minimum_lead
                                  ? "enError outlined-KilometersAway"
                                  : "outlined-KilometersAway"
                                  }`}
                                onChange={formik.handleChange}
                                value={formik.values.minimum_lead}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.minimum_lead &&
                                  formik.touched.minimum_lead
                                }
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {MinimumLeadTime &&
                                  MinimumLeadTime.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <p className="f12-500">Minutes</p>
                          </div>
                          <div className="col-6">
                            {formik.errors.minimum_lead &&
                              formik.touched.minimum_lead ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.minimum_lead}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className=" col-6 col-md-8 col-lg-6 p-0">
                    <div className="f12-500">Cut Off Time - Order</div>
                    <div className="f11-400 opacity5">
                      (Last Order as per the Hours of Operation)
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                name="cut_off_time"
                                id="cut_off_time"
                                className={`w-100 ${formik.errors.cut_off_time &&
                                  formik.touched.cut_off_time
                                  ? "enError outlined-Minutes"
                                  : "outlined-Minutes"
                                  }`}
                                onChange={formik.handleChange}
                                value={formik.values.cut_off_time}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.cut_off_time &&
                                  formik.touched.cut_off_time
                                }
                                // className="outlined-Minutes"
                                IconComponent={KeyboardArrowDownIcon}
                                disabled={disabled}
                              >
                                {CutOffTimeData &&
                                  CutOffTimeData.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-3 col-md-6">
                            <Media query="(min-width:991px)">
                              <p className="f12-500">Minutes</p>
                            </Media>
                            <Media query="(max-width:991px)">
                              <p className="f12-500">Mins</p>
                            </Media>
                          </div>
                          <div className="col-6">
                            {formik.errors.cut_off_time &&
                              formik.touched.cut_off_time ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.cut_off_time}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="row mb-3 mt-4">
                  <div className=" col-6 col-md-6 col-lg-6">
                    <div className="f12-500">
                      Auto Cancel&nbsp;
                      <i
                        className="fa fa-info-circle"
                        style={{ color: "#9E9E9E" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="f11-400 opacity5">
                      (Acceptance period for pending requests when restaurant is
                      open)
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-lg-3">
                    <Row>
                      <Col md={12}>
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={role === 'superadmin' ? false : true}
                        >
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_cancel_open_restaurant"
                            disabled={role === 'superadmin' ? false : true}
                            onInput={maxLengthCheck}
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_cancel_open_restaurant}
                            // labelText="Minutes"
                            controlClass="auto_cancel_open_restaurant"
                          />
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="col-3 f12-500 m-auto">Minutes</div>
                </div>
                <div className="row mb-3">
                  <div className=" col-6 col-md-6 col-lg-6">
                    <div className="f12-500">
                      Auto Cancel&nbsp;
                      <i
                        className="fa fa-info-circle"
                        style={{ color: "#9E9E9E" }}
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div className="f11-400 opacity5">
                      (Acceptance period for pending requests when restaurant is
                      close)
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-lg-3">
                    <Row>
                      <Col md={12}>
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                          disabled={disabled}
                        >
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_cancel_close_restaurant"
                            disabled={role === 'superadmin' ? false : true}
                            onInput={maxLengthCheck}
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_cancel_close_restaurant}
                            // labelText="Minutes"
                            controlClass="auto_cancel_close_restaurant"
                          />
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="col-3 f12-500 m-auto">Minutes</div>
                </div>
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Delivery partner
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <Row>
                      <Col md={12}>
                        <div className="row align-items-center">
                          <div className="col-9 col-md-6">
                            <FormControl variant="outlined" className={"w-100"}>
                              <Select
                                name="delivery_partner"
                                id="delivery_partner"
                                className={`w-100 ${formik.errors.delivery_partner &&
                                  formik.touched.delivery_partner
                                  ? "enError outlined-KilometersAway"
                                  : "outlined-KilometersAway"
                                  }`}
                                onChange={formik.handleChange}
                                value={formik.values.delivery_partner}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  formik.errors.delivery_partner &&
                                  formik.touched.delivery_partner
                                }
                                IconComponent={KeyboardArrowDownIcon}
                                disabled={disabled}
                              >
                                {delivery_options &&
                                  delivery_options.map((item, index) => {
                                    return (
                                      <MenuItem key={index} value={item.value}>
                                        {item.title}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>

                          <div className="col-6">
                            {formik.errors.distance &&
                              formik.touched.distance ? (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.distance}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div>
                  {+formik.values.delivery_partner == 1 && (
                    <div className="f14-500 mb-2">
                      Maintain Delivery Persons
                      {props?.auth?.loader ?
                        <div className="d-flex align-items-center w-100 justify-content-center">
                          <Loader type="Bars" color="#00BFFF" height={40} width={40} />
                        </div>
                        :
                        !isEmpty(deliveryPersonArr) && deliveryPersonArr.map((item, index) => (
                          <DeliveryPersonInfoReuse
                            keyType={index}
                            name={item?.full_name}
                            mobile={item?.mobile_number}
                            age={item.age} gender={item.gender}
                            profile_image={item.profile_image}
                            license_document={item.driving_license}
                            onClickEdit={onClickEditDeliveryPerson(item, index)}
                            onClickDelete={() => confirmDeleteModal(item, index)}
                          // onClickDelete={() => handleShowDel(item, index)}
                          />
                        ))}
                      <br />
                      <Image
                        className="pr-2"
                        onClick={handleShowAdd}
                        src={require("../../../../../../../assets/images/ActionImages/Add-delivery-person-img.png")}
                        alt="Add "
                        fluid
                      />
                      <ButtonReusableComponent
                        buttonType={"button"}
                        buttonClass={"simpleRed"}
                        onClick={handleShowAdd}
                        disabled={false}
                        buttonText={"Add New Delivery Person"}
                      />
                    </div>
                  )}
                  {showAdd && <AddOrEditDeliveryPersonModal showAddEdit={showAdd} handleCloseAdd={handleCloseAdd} actionData={editDeliveryPerson} onValueRedirect={onClickAddEditDeliveryPerson} />
                  }
                </div>


                {removePerson && <Modal show={removePerson} onHide={handleCloseDel} centered>
                  <Modal.Header className="py-0 pt-2 border-0" closeButton>
                    <Modal.Title>Confirm Removal?</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="f14-500">
                    Are you sure you want to remove this delivery person from the list?<br /><br />They will no longer be available for selection when assigning delivery orders.
                  </Modal.Body>
                  <Modal.Footer className="justify-content-start border-0">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5"
                      onClick={handleCloseDel}
                    >
                      cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={() => handleShowDel(deleteData?.deleteInfo, deleteData?.index)}
                    >
                      Remove Delivery Person
                    </Button>
                  </Modal.Footer>

                </Modal>}
                <hr className="mt-4 mb-3 m-0" />
                <div className="f14-500">
                  Maintain Delivery Charges
                </div>
                {(props.onboarding?.pos?.restId !== "" && formik.values.delivery_partner == 1) &&
                  <div className="d-flex align-items-center py-3">
                    <div className="f12-500 col-6 col-md-6 col-lg-6 p-0">
                      Delivery Charges
                      <div className="f11-400 opacity5 w-75">
                        (Point of sale charges for self delivery)
                      </div>
                    </div>

                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                            disabled={disabled}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="delivery_charges"
                              maxLength={5}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.delivery_charges}
                              controlClass="delivery_charges"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                }
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Fix Rate Distribution
                    {formik.values.deliveryConfig?.isFixed && <div className="f11-400 opacity5 w-75">
                      Fixed charges will be split between Merchant and Amealio while rest  will be borne by the User
                    </div>}
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={formik.values.deliveryConfig?.isFixed}
                      checkedBox={formik.values.deliveryConfig?.isFixed}
                      onChange={() => {
                        formik.setFieldValue("deliveryConfig.isFixed", !formik.values.deliveryConfig.isFixed)
                        if (!formik.values.deliveryConfig.isFixed) formik.setFieldValue("deliveryConfig.isPercentage", false)
                      }}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={role === 'superadmin' ? false : true}
                    />
                  </div>
                </div>
                {formik.values.deliveryConfig?.isFixed && <>
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Distance upto 3Km
                  </div>
                  <div className="row mb-3">
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.below3.merchant"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={(role === 'superadmin' && !formik.values.deliveryConfig.fixedCharges.below3.borneByMerchant) ? false : true}

                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.below3?.merchant}
                              labelText="For Merchant Rs"
                            // controlClass="deliveryConfig.userCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.below3.amealio"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={(role === 'superadmin' && !formik.values.deliveryConfig.fixedCharges.below3.borneByMerchant) ? false : true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.below3?.amealio}
                              labelText="For Amealio Rs"
                            // controlClass="deliveryConfig.merchantCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.below3.user"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.below3?.user}
                              labelText="For User Rs"
                            // controlClass="deliveryConfig.amealioCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-3">
                    <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                      Completely borne by Merchant
                    </div>
                    <div className="col-6 col-md-4 col-lg-6">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.deliveryConfig?.fixedCharges?.below3?.borneByMerchant}
                        checkedBox={formik.values.deliveryConfig?.fixedCharges?.below3?.borneByMerchant}
                        onChange={() => {
                          formik.setFieldValue("deliveryConfig.fixedCharges.below3.borneByMerchant", !formik.values.deliveryConfig?.fixedCharges?.below3?.borneByMerchant)
                        }}
                        name="deliveryConfig.fixedCharges.below3.borneByMerchant"
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                        disabled={role === 'superadmin' ? false : true}
                      />
                    </div>
                  </div>
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Distance above 3Km
                  </div>
                  <div className="row mb-3">
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.above3.merchant"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={role === 'superadmin' ? false : true}

                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.above3?.merchant}
                              labelText="For Merchant Rs"
                              controlClass="deliveryConfig.userCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>

                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.above3.amealio"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={role === 'superadmin' ? false : true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.above3?.amealio}
                              labelText="For Amealio Rs"
                              controlClass="deliveryConfig.merchantCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.fixedCharges.above3.user"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.fixedCharges?.above3?.user}
                              labelText="For User Rs"
                              controlClass="deliveryConfig.amealioCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </>}
                <div className="d-flex align-items-center justify-content-between py-3">
                  <div className="f12-500 col-6 col-md-8 col-lg-6 p-0">
                    Percentage Distribution
                    {formik.values.deliveryConfig?.isPercentage && <div className="f11-400 opacity5 w-75">
                      Based on the percentage, charges will be split between Merchant, Amealio and User
                    </div>}
                  </div>

                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={formik.values.deliveryConfig?.isPercentage}
                      checkedBox={formik.values.deliveryConfig?.isPercentage}
                      onChange={() => {
                        formik.setFieldValue("deliveryConfig.isPercentage", !formik.values.deliveryConfig.isPercentage)
                        if (!formik.values.deliveryConfig.isPercentage) formik.setFieldValue("deliveryConfig.isFixed", false)
                      }}
                      name="deliveryConfig.isPercentage"
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={role === 'superadmin' ? false : true}
                    />
                  </div>
                </div>
                {formik.values.deliveryConfig?.isPercentage && <>
                  <div className="row mb-3">
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.merchantCharge"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={role === 'superadmin' ? false : true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.merchantCharge}
                              labelText="For Merchant %"
                              controlClass="deliveryConfig.merchantCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.amealioCharge"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={role === 'superadmin' ? false : true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.amealioCharge}
                              labelText="For Amealio %"
                              controlClass="deliveryConfig.amealioCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                    <div className="col-3 col-md-3 col-lg-3">
                      <Row>
                        <Col md={12}>
                          <FormControl
                            variant="outlined"
                            className={"w-100"}
                          >
                            <NewInputText
                              extraClass="mb-1"
                              name="deliveryConfig.userCharge"
                              onInput={maxLengthCheck}
                              maxLength={3}
                              disabled={role === 'superadmin' ? false : true}
                              inputType="number"
                              onFocusOut={formik.handleBlur}
                              onChange={formik.handleChange}
                              value={formik.values.deliveryConfig?.userCharge}
                              labelText="For User %"
                              controlClass="deliveryConfig.userCharge"
                            />
                          </FormControl>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </>}
                <div className="row mb-3">
                  <div className=" col-6 col-md-6 col-lg-6">
                    <div className="f12-500">
                      Refund Cancel Delivery
                    </div>
                  </div>
                  <div className="col-3 col-md-3 col-lg-3">
                    <Row>
                      <Col md={12}>
                        <FormControl
                          variant="outlined"
                          className={"w-100"}
                        >
                          <NewInputText
                            extraClass="mb-1"
                            name="deliveryConfig.cancelRefund"
                            onInput={maxLengthCheck}
                            maxLength={3}
                            disabled={role === 'superadmin' ? false : true}
                            inputType="number"
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.deliveryConfig?.cancelRefund}
                            // labelText="Minutes"
                            controlClass="deliveryConfig.cancelRefund"
                          />
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="col-3 f12-500 m-auto">%</div>
                </div>
                <div className="d-flex justify-content-between py-3">
                  <div className=" col-6 col-md-8 col-lg-6 p-0">
                    <div className="f12-500">
                      Maintain order status on item level
                    </div>
                    <div className="f11-400 opacity5 w-75">
                      (Enable this to maintain order status like accepted,
                      getting prepared etc on item level. If you don't enable
                      this it will be maintained on order level)
                    </div>
                  </div>
                  <div className="col-6 col-md-4 col-lg-6">
                    <ToggleButtonWithYesNo
                      activeClass={state.order_status_item_level}
                      checkedBox={state.order_status_item_level}
                      onChange={onClickhomeDeliveryService(
                        "MaintainOrderStatus"
                      )}
                      extraClass="d-flex align-items-center"
                      extraYesNo="f12-500"
                      disabled={disabled}
                    />
                  </div>
                </div>
                <br />
                <br />
                <div
                  className="onboarding-map-setup-screen-autodetect-button pt-4"
                  style={{ marginBottom: "50px" }}
                >
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/edit-ordering-subscription"
                  />
                  {!disabled && (
                    <ReusableOnboardingButton
                      buttonTitle="Done Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="button"
                      onClick={() => onClickSave()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </React.Fragment>
    );
  }
};

EditCasualHomeDelivery.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
  get_delivery_person: PropTypes.func.isRequired,
  delete_delivery_person: PropTypes.func.isRequired,
  add_delivery_person: PropTypes.func.isRequired,
  edit_delivery_person: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state?.onboarding && state?.onboarding?.restaurantDetails,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
      state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.ordering?.home_delivery
      : state?.onboarding?.onboard_subscription_details?.fast_food_dining &&
        state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
        ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
          ?.ordering?.home_delivery
        : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.ordering?.home_delivery,
  allSubscriptionsData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  deliveryInfo: state?.deliveryPersonData && state?.deliveryPersonData?.get_all_deliveryPerson
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  get_delivery_person,
  delete_delivery_person,
  add_delivery_person,
  edit_delivery_person,
})(withRouter(EditCasualHomeDelivery));
